<template>
    <div class="invitation-page">
        <v-container class="text-xs-center invitation-wrapper">
            <v-dialog v-model="dialog" max-width="500px">
                <v-card>
                    <v-form
                            v-on:submit.prevent="validate()"
                            ref="form"
                    >
                        <v-card-title>
                            <span class="headline">{{$t('add_new_employee')}}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <div class="flex">
                                    <v-text-field
                                            autofocus
                                            v-model="celular_nuevo"
                                            prepend-icon="phone_iphone"
                                            name="celular_nuevo"
                                            :label="$t('celular')"
                                            counter="10"
                                            maxlength="10"
                                            :rules="[rules.required, rules.counter, rules.number]"
                                    >
                                    </v-text-field>
                                </div>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    @click="dialog = false"
                            >{{$t('cerrar')}}</v-btn>
                            <v-btn
                                    color="primary"
                                    @click="validate()"
                            >{{$t('agregar')}}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
            <v-dialog
                    v-model="dialog_bloqueo"
                    persistent
                    width="500"
            >
                <v-card class="elevation-0">
                    <v-toolbar class="mb-0" dark color="warning">
                        <v-toolbar-title>
                            {{$t('aviso')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout align-center justify-center>
                            <h2>{{$t('pagina_caduca')}}</h2>
                            <v-btn
                                    color="primary"
                                    large
                                    to="/home"
                            >
                                <v-icon left>home</v-icon>
                                {{$t('inicio')}}
                            </v-btn>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog
                    v-model="dialog_sin_permisos"
                    persistent
                    width="500"
            >
                <v-card class="elevation-0">
                    <v-toolbar class="mb-0" dark color="warning">
                        <v-toolbar-title>
                            {{$t('aviso')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout align-center justify-center>
                            <h2>{{$t('sin_permisos')}}</h2>
                            <v-btn
                                    color="primary"
                                    large
                                    to="/home"
                            >
                                <v-icon left>home</v-icon>
                                {{$t('inicio')}}
                            </v-btn>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-layout row wrap>
                <v-flex md12>
                    <v-card class="elevation-2 invitation-card">
                        <v-toolbar class="mb-1" dark color="primary">
                            <v-toolbar-title>
                                Datos de la Invitación
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>

                        <!-- Hero: logo + info empresa -->
                        <v-card-text class="pb-0">
                            <v-layout row wrap align-center class="company-hero">
                                <v-flex xs12 sm4 class="company-hero-logo-col">
                                    <div class="company-logo-frame">
                                        <v-img
                                            v-if="info && info.empresa_a && info.empresa_a.logo"
                                            class="centrado"
                                            :src="info.empresa_a.logo"
                                            height="140"
                                            contain
                                        ></v-img>
                                        <div v-else class="logo-fallback d-flex align-center justify-center">
                                            <v-icon color="primary" size="52">local_shipping</v-icon>
                                        </div>
                                    </div>
                                </v-flex>
                                <v-flex xs12 sm8 class="company-hero-info-col">
                                    <div class="display-hero-title primary--text">
                                        {{ info && info.empresa_a ? info.empresa_a.name : (info && info.host ? info.host.name_company : 'Embarque') }}
                                    </div>
                                    <div class="subheading grey--text text--darken-1 mb-3">Invitación de embarque</div>
                                    <v-chip v-if="info && info.is_internal" small color="teal" text-color="white" class="mb-2">
                                        <v-icon left small>person_pin</v-icon>
                                        {{ getMovementTypeLabel() }} interno
                                    </v-chip>
                                    <div v-if="info && info.shipping_window">
                                        <v-chip small color="primary" text-color="white" class="mr-2">
                                            <v-icon left small>event</v-icon>
                                            {{ info.shipping_window.window_date }}
                                        </v-chip>
                                        <v-chip small outline color="primary">
                                            <v-icon left small>schedule</v-icon>
                                            {{ info.shipping_window.window_time }}
                                        </v-chip>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <!-- Banner empresa externa -->
                            <div v-if="isInvitationExternal && info && info.empresa_b && info.empresa_a" class="mt-4 mb-2">
                                <v-alert :value="true" type="info" outline class="mb-3 subheading" color="primary">
                                    <strong>{{ info.empresa_b.name }}</strong> te ha asignado como proveedor logístico para un embarque en <strong>{{ info.empresa_a.name }}</strong>.
                                </v-alert>
                                <v-layout row wrap class="align-center justify-center text-xs-center mb-2">
                                    <v-flex xs12 sm5 class="pa-2">
                                        <v-avatar size="72" class="mb-2 elevation-1" color="white">
                                            <v-img :src="info.empresa_b.logo" v-if="info.empresa_b.logo" contain></v-img>
                                            <v-icon v-else large>business</v-icon>
                                        </v-avatar>
                                        <div class="subheading font-weight-bold primary--text">{{ info.empresa_b.name }}</div>
                                        <div class="body-1 grey--text mt-1 text-truncate" :title="info.empresa_b.address">{{ info.empresa_b.address }}</div>
                                    </v-flex>
                                    <v-flex xs12 sm2 class="pa-2 d-flex align-center justify-center hidden-xs-only">
                                        <v-icon size="36" color="grey lighten-1">arrow_forward</v-icon>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2 d-flex align-center justify-center hidden-sm-and-up">
                                        <v-icon size="28" color="grey lighten-1">arrow_downward</v-icon>
                                    </v-flex>
                                    <v-flex xs12 sm5 class="pa-2">
                                        <v-avatar size="72" class="mb-2 elevation-1" color="white">
                                            <v-img :src="info.empresa_a.logo" v-if="info.empresa_a.logo" contain></v-img>
                                            <v-icon v-else large>business</v-icon>
                                        </v-avatar>
                                        <div class="subheading font-weight-bold primary--text">{{ info.empresa_a.name }}</div>
                                        <div class="body-1 grey--text mt-1 text-truncate" :title="info.empresa_a.address">{{ info.empresa_a.address }}</div>
                                    </v-flex>
                                </v-layout>
                                <v-divider class="mb-2"></v-divider>
                            </div>
                        </v-card-text>

                        <v-card-text>
                            <v-form class="mb-4" @submit.prevent="create_invt_empresarial()">

                                <!-- Detalles del embarque -->
                                <v-subheader class="primary--text font-weight-bold pl-0">
                                    <v-icon small class="mr-2" color="primary">event_note</v-icon>
                                    Detalles del embarque
                                </v-subheader>
                                <v-divider class="mb-2"></v-divider>
                                <table class="inv-details-table">
                                    <tbody>
                                        <tr>
                                            <td class="inv-dt-label"><v-icon small color="primary" class="mr-1">business</v-icon>{{ $t('lbl_host_company') }}</td>
                                            <td class="inv-dt-value">{{ info && info.host ? info.host.name_company : '' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="inv-dt-label"><v-icon small color="primary" class="mr-1">person</v-icon>{{ $t('Anfitrion') }}</td>
                                            <td class="inv-dt-value">{{ info && info.host ? (info.host.first_name + ' ' + info.host.last_name) : '' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="inv-dt-label"><v-icon small color="primary" class="mr-1">today</v-icon>{{ $t('fecha_hora') }}</td>
                                            <td class="inv-dt-value">
                                                {{ info && info.shipping_window ? info.shipping_window.window_date : '' }}
                                                {{ info && info.shipping_window ? info.shipping_window.window_time : '' }}
                                            </td>
                                        </tr>
                                        <tr v-if="info && info.shipping_window && info.shipping_window.tipo_movimiento_display">
                                            <td class="inv-dt-label"><v-icon small color="primary" class="mr-1">local_shipping</v-icon>Tipo de movimiento</td>
                                            <td class="inv-dt-value">{{ info.shipping_window.tipo_movimiento_display }}</td>
                                        </tr>
                                        <tr>
                                            <td class="inv-dt-label"><v-icon small color="primary" class="mr-1">store</v-icon>{{ $t('landing_area') }}</td>
                                            <td class="inv-dt-value">{{ info && info.shipping_window && info.shipping_window.loading_area_detail ? info.shipping_window.loading_area_detail.name : '' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="inv-dt-label"><v-icon small color="primary" class="mr-1">business_center</v-icon>Plantas destino</td>
                                            <td class="inv-dt-value">
                                                <div v-if="info && info.shipping_window && info.shipping_window.clients_detail">
                                                    <v-chip v-for="(client, idx) in info.shipping_window.clients_detail" :key="idx" small class="mr-2 mb-2" color="primary" text-color="white">
                                                        {{ client.name }}
                                                    </v-chip>
                                                </div>
                                                <span v-else-if="info && info.shipping_window && info.shipping_window.client_detail">
                                                    {{ info.shipping_window.client_detail.name }}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="inv-dt-label"><v-icon small color="primary" class="mr-1">place</v-icon>Direcciones de plantas destino</td>
                                            <td class="inv-dt-value">
                                                <div v-if="info && info.shipping_window && info.shipping_window.clients_detail">
                                                    <div v-for="(client, idx) in info.shipping_window.clients_detail" :key="idx" class="mb-2">
                                                        <strong>{{ client.name }}:</strong> {{ client.address }}
                                                    </div>
                                                </div>
                                                <span v-else-if="info && info.shipping_window && info.shipping_window.client_detail">
                                                    {{ info.shipping_window.client_detail.address }}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr v-if="notes">
                                            <td class="inv-dt-label"><v-icon small color="primary" class="mr-1">notes</v-icon>{{ $t('Notas') }}</td>
                                            <td class="inv-dt-value">{{ notes }}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <!-- Estado / Acciones -->
                                <div v-if="info && info.shipping_window">

                                    <!-- PROGRAMADA -->
                                    <div v-if="info.shipping_window.status === 'PROGRAMADA'" class="mt-4">
                                        <!-- Mostrar conductor asignado si existe (recepción con empleado asignado) -->
                                        <template v-if="info.is_internal && info.internal_driver">
                                            <v-subheader class="teal--text font-weight-bold pl-0">
                                                <v-icon small class="mr-2" color="teal">person_pin</v-icon>
                                                Conductor/Empleado asignado
                                            </v-subheader>
                                            <v-divider class="mb-3"></v-divider>
                                            <v-card class="elevation-1 mb-3">
                                                <v-list two-line>
                                                    <v-list-tile avatar>
                                                        <v-list-tile-avatar size="52" color="teal lighten-4">
                                                            <v-icon color="teal">person</v-icon>
                                                        </v-list-tile-avatar>
                                                        <v-list-tile-content>
                                                            <v-list-tile-title class="font-weight-bold">{{ info.internal_driver.first_name }} {{ info.internal_driver.last_name }}</v-list-tile-title>
                                                            <v-list-tile-sub-title>{{ info.internal_driver.email }}</v-list-tile-sub-title>
                                                        </v-list-tile-content>
                                                    </v-list-tile>
                                                </v-list>
                                                <v-divider></v-divider>
                                                <v-card-text class="pt-2 pb-2">
                                                    <table class="inv-details-table">
                                                        <tbody>
                                                            <tr v-if="info.internal_driver.company">
                                                                <td class="inv-dt-label"><v-icon small color="teal" class="mr-1">business</v-icon>Empresa</td>
                                                                <td class="inv-dt-value">{{ info.internal_driver.company }}</td>
                                                            </tr>
                                                            <tr v-if="info.internal_driver.phone">
                                                                <td class="inv-dt-label"><v-icon small color="teal" class="mr-1">phone</v-icon>Teléfono</td>
                                                                <td class="inv-dt-value">{{ info.internal_driver.phone }}</td>
                                                            </tr>
                                                            <tr v-if="info.internal_driver.position">
                                                                <td class="inv-dt-label"><v-icon small color="teal" class="mr-1">work</v-icon>Puesto</td>
                                                                <td class="inv-dt-value">{{ info.internal_driver.position }}</td>
                                                            </tr>
                                                            <template v-if="info.internal_driver.vehicle">
                                                                <tr>
                                                                    <td class="inv-dt-label"><v-icon small color="teal" class="mr-1">local_shipping</v-icon>Vehículo</td>
                                                                    <td class="inv-dt-value">{{ info.internal_driver.vehicle.type }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="inv-dt-label"><v-icon small color="teal" class="mr-1">directions_car</v-icon>Placa</td>
                                                                    <td class="inv-dt-value">{{ info.internal_driver.vehicle.license_plate }}</td>
                                                                </tr>
                                                                <tr v-if="info.internal_driver.vehicle.capacity_tonnage">
                                                                    <td class="inv-dt-label"><v-icon small color="teal" class="mr-1">fitness_center</v-icon>Capacidad</td>
                                                                    <td class="inv-dt-value">{{ info.internal_driver.vehicle.capacity_tonnage }} ton</td>
                                                                </tr>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </v-card-text>
                                            </v-card>
                                        </template>

                                        <!-- Opciones de confirmación -->
                                        <v-subheader class="primary--text font-weight-bold pl-0">
                                            <v-icon small class="mr-2" color="primary">help_outline</v-icon>
                                            ¿Acepta la invitación?
                                        </v-subheader>
                                        <v-divider class="mb-3"></v-divider>
                                        <v-layout justify-start class="ml-1">
                                            <v-btn color="success" :loading="loading_confirm" @click="adminConfirmAction('confirm')">
                                                <v-icon left>check_circle</v-icon>Aceptar
                                            </v-btn>
                                            <v-btn color="error" :loading="loading_confirm" class="ml-2" @click="adminConfirmAction('decline')">
                                                <v-icon left>cancel</v-icon>Rechazar
                                            </v-btn>
                                        </v-layout>
                                    </div>

                                    <!-- CANCELADA -->
                                    <v-alert v-if="info.shipping_window.status === 'CANCELADA'" :value="true" type="error" outline class="mt-4">
                                        {{ $t('invitation_rejected') }}
                                    </v-alert>

                                    <!-- CONFIRMADA -->
                                    <div v-if="info.shipping_window.status === 'CONFIRMADA'" class="mt-4">

                                        <!-- Embarque interno: mostrar conductor asignado, sin formulario de invitación -->
                                        <template v-if="info.is_internal && info.internal_driver">
                                            <v-subheader class="teal--text font-weight-bold pl-0">
                                                <v-icon small class="mr-2" color="teal">person_pin</v-icon>
                                                Conductor interno asignado
                                            </v-subheader>
                                            <v-divider class="mb-3"></v-divider>
                                            <v-alert :value="true" type="success" outline class="mb-3">
                                                Este {{ getMovementTypeLabel().toLowerCase() }} es <strong>interno</strong>. El conductor ya está asignado y confirmado por la empresa.
                                            </v-alert>
                                            <v-card class="elevation-1 mb-3">
                                                <v-list two-line>
                                                    <v-list-tile avatar>
                                                        <v-list-tile-avatar size="52" color="teal lighten-4">
                                                            <v-icon color="teal">person</v-icon>
                                                        </v-list-tile-avatar>
                                                        <v-list-tile-content>
                                                            <v-list-tile-title class="font-weight-bold">{{ info.internal_driver.first_name }} {{ info.internal_driver.last_name }}</v-list-tile-title>
                                                            <v-list-tile-sub-title>{{ info.internal_driver.email }}</v-list-tile-sub-title>
                                                        </v-list-tile-content>
                                                        <v-list-tile-action>
                                                            <v-chip small color="success" text-color="white">
                                                                <v-icon left small>check_circle</v-icon>
                                                                Confirmado
                                                            </v-chip>
                                                        </v-list-tile-action>
                                                    </v-list-tile>
                                                </v-list>
                                                <v-divider></v-divider>
                                                <v-card-text class="pt-2 pb-2">
                                                    <table class="inv-details-table">
                                                        <tbody>
                                                            <tr>
                                                                <td class="inv-dt-label"><v-icon small color="teal" class="mr-1">business</v-icon>Empresa</td>
                                                                <td class="inv-dt-value">{{ info.internal_driver.company }}</td>
                                                            </tr>
                                                            <tr v-if="info.internal_driver.phone">
                                                                <td class="inv-dt-label"><v-icon small color="teal" class="mr-1">phone</v-icon>Teléfono</td>
                                                                <td class="inv-dt-value">{{ info.internal_driver.phone }}</td>
                                                            </tr>
                                                            <tr v-if="info.internal_driver.position">
                                                                <td class="inv-dt-label"><v-icon small color="teal" class="mr-1">work</v-icon>Puesto</td>
                                                                <td class="inv-dt-value">{{ info.internal_driver.position }}</td>
                                                            </tr>
                                                            <template v-if="info.internal_driver.vehicle">
                                                                <tr>
                                                                    <td class="inv-dt-label"><v-icon small color="teal" class="mr-1">local_shipping</v-icon>Vehículo</td>
                                                                    <td class="inv-dt-value">{{ info.internal_driver.vehicle.type }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="inv-dt-label"><v-icon small color="teal" class="mr-1">directions_car</v-icon>Placa</td>
                                                                    <td class="inv-dt-value">{{ info.internal_driver.vehicle.license_plate }}</td>
                                                                </tr>
                                                                <tr v-if="info.internal_driver.vehicle.capacity_tonnage">
                                                                    <td class="inv-dt-label"><v-icon small color="teal" class="mr-1">fitness_center</v-icon>Capacidad</td>
                                                                    <td class="inv-dt-value">{{ info.internal_driver.vehicle.capacity_tonnage }} ton</td>
                                                                </tr>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </v-card-text>
                                            </v-card>
                                        </template>

                                        <!-- Embarque externo: formulario de invitación normal -->
                                        <template v-else-if="!info.is_internal">
                                            <v-subheader class="primary--text font-weight-bold pl-0">
                                                <v-icon small class="mr-2" color="primary">group_add</v-icon>
                                                Invitar participantes
                                            </v-subheader>
                                            <v-divider class="mb-3"></v-divider>

                                            <v-checkbox
                                                v-if="getProfile.roll !== 6 && !isInvitationExternal"
                                                v-model="isExternalInvite"
                                                :label="$t('invitar_empresa_externa')"
                                                class="ml-1 mb-2"
                                            ></v-checkbox>

                                            <!-- Empleados internos -->
                                            <v-autocomplete
                                                v-if="!isExternalInvite"
                                                return-object
                                                multiple
                                                v-model="email"
                                                :items="items"
                                                prepend-icon="email"
                                                :loading="isLoading"
                                                :search-input.sync="search"
                                                :item-text="fullNamePlusCellphone"
                                                item-value="celular"
                                                :placeholder="$t('placeholder_invitados2')"
                                                :label="$t('Empleados')"
                                                :error-messages="errores.guest"
                                                :no-data-text="$t('no_resultados')"
                                                chips
                                                clearable
                                            >
                                                <template v-slot:selection="data">
                                                    <v-chip :selected="data.selected" class="chip--select-multi">
                                                        {{ data.item.id_usuario.first_name }} {{ data.item.id_usuario.last_name }}
                                                    </v-chip>
                                                </template>
                                                <template v-slot:item="data">
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>{{ data.item.id_usuario.first_name }} {{ data.item.id_usuario.last_name }}</v-list-tile-title>
                                                        <v-list-tile-sub-title>{{ data.item.id_usuario.email }}</v-list-tile-sub-title>
                                                    </v-list-tile-content>
                                                </template>
                                            </v-autocomplete>

                                            <!-- Empresa externa -->
                                            <div v-if="isExternalInvite && getProfile.roll !== 6">
                                                <v-radio-group v-model="companyType" row class="mt-0">
                                                    <v-radio :label="$t('empresa_existente')" value="existing"></v-radio>
                                                    <v-radio :label="$t('empresa_no_registrada')" value="unregistered"></v-radio>
                                                </v-radio-group>
                                                <template v-if="companyType === 'existing'">
                                                    <v-autocomplete
                                                        v-model="selectedCompanyObj"
                                                        :items="companiesList"
                                                        :loading="isLoadingCompanies"
                                                        :search-input.sync="searchCompany"
                                                        item-text="name"
                                                        return-object
                                                        :label="$t('buscar_empresa')"
                                                        prepend-icon="business"
                                                        :placeholder="$t('escriba_para_buscar')"
                                                        @change="onCompanySelect"
                                                    >
                                                        <template v-slot:item="data">
                                                            <v-list-tile-content>
                                                                <v-list-tile-title>{{ data.item.name }}</v-list-tile-title>
                                                                <v-list-tile-sub-title>{{ data.item.email }}</v-list-tile-sub-title>
                                                            </v-list-tile-content>
                                                        </template>
                                                    </v-autocomplete>
                                                </template>
                                                <template v-else>
                                                    <v-text-field v-model="externalCompanyName" :label="$t('nombre_empresa')" prepend-icon="business" :rules="[rules.required]"></v-text-field>
                                                    <v-text-field v-model="externalContactName" :label="$t('nombre_contacto')" prepend-icon="person" :rules="[rules.required]"></v-text-field>
                                                    <v-text-field v-model="externalContactEmail" :label="$t('correo_contacto')" prepend-icon="email" :rules="[rules.required, rules.email]"></v-text-field>
                                                </template>
                                            </div>

                                            <v-divider class="mt-3 mb-3"></v-divider>
                                            <v-layout justify-end>
                                                <v-btn color="primary" :loading="loading_send" @click="create_invt_empresarial()">
                                                    <v-icon left>send</v-icon>
                                                    {{ $t('enviar') }}
                                                </v-btn>
                                            </v-layout>
                                        </template>
                                    </div>

                                </div>

                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import {mapGetters, mapState} from 'vuex'

    Vue.use(VeeValidate)

    export default {
        name: "form_shipping_window_invitation_data",
        data () {
            return {
                rules: {
                    required: value => !!value || 'Campo Requerido',
                    counter: value => value.length >= 10 || 'El Número de Celular debe de contener 10 dígitos',
                    number: value => {
                        const pattern = /^\d+$/
                        return pattern.test(value) || 'Ingresa un Campo Númerico.'
                    },
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Dirección E-Mail no Válida.'
                    },
                },
                info: '',
                vehicle: '',
                notes: '',
                cellphone: '',
                email: '',
                errores: [],
                dialog_bloqueo: false,
                dialog_sin_permisos: false,
                dialog: false,
                celular_nuevo: '',
                entries: [],
                isLoading: false,
                search: null,
                loading_send: false,
                today: '',
                isExternalInvite: false,
                isInvitationExternal: false,
                externalCompanyName: '',
                externalContactName: '',
                externalContactEmail: '',
                companyType: 'unregistered',
                companiesList: [],
                isLoadingCompanies: false,
                searchCompany: '',
                selectedCompanyObj: null,
                loading_confirm: false

            }
        },
        computed: {
            ...mapGetters(['getProfile']),
            ...mapState(['language']),
            fields () {
                if (!this.email) return []

                return Object.keys(this.email).map(key => {
                    return {
                        key,
                        value: this.email[key] || 'n/a'
                    }
                })
            },
             items () {
        return this.entries.map(entry => {
            return Object.assign({}, entry)  // sin modificar, la estructura ya viene bien
        })
    }
        },
        watch: {
            isUpdating (val) {
                if (val) {
                    setTimeout(() => (this.isUpdating = false), 3000)
                }
            },
            companyType (val) {
                if (val === 'existing') {
                     this.isLoadingCompanies = true;
                     const config = {
                        method: 'get',
                        url: 'https://empresa-service.intrare.app/getProvidersByAdmin', 
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        }
                    };
                    axios(config)
                        .then(response => {
                            // Mapping to a more usable format if necessary, or just using raw
                            // Verify structure from proveedores.vue: response.data is array of objects
                            // each object has companyProvider { name, ... } and root properties (user info?)
                            this.companiesList = response.data.map(item => ({
                                ...item,
                                name: item.companyProvider ? item.companyProvider.name : (item.name || 'Sin Nombre'),
                                // Ensure we have a label for the autocomplete
                            }));
                        })
                        .catch(error => {
                            console.error(error);
                        })
                        .finally(() => {
                            this.isLoadingCompanies = false;
                        });
                }
            }
        },
        created: function(){
            this.get_info_invit_empresarial()
            this.get_all_employees()
        },
        methods:{
            get_all_employees(){
                this.isLoading = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/empleados/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.entries = Array.isArray(response.data) ? response.data : []
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => (this.isLoading = false))
            },
            validate () {
                if (this.$refs.form.validate()) {
                    this.dialog = false
                    this.add_new_employee()
                }
            },
            add_new_employee(){
                this.entries.push(
                    {
                        "email": '',
                        "celular": this.celular_nuevo
                    }
                )
                this.email.push(
                    {
                        "email": '',
                        "celular": this.celular_nuevo
                    }
                )
            },
            get_info_invit_empresarial(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getShipmentInvitation/' + this.$route.params['token'] + '/',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                axios(config)
                    .then(response => {

                        if (response.status === 204) {
                            this.dialog_bloqueo = true
                            console.log('Página Expirada .... overlay = ', this.dialog_bloqueo)
                        } else {
                            this.info = response.data
                            this.isInvitationExternal = response.data.is_external_invitation
                            this.notes = response.data.shipping_window.observations
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            get_current_date(){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd
                }

                if(mm<10)
                {
                    mm='0'+mm
                }
                this.today = yyyy + '-' + mm + '-' + dd
            },
            create_invt_empresarial(){
                this.$validator.validateAll().then((result) => {
                    // Manually validate external fields if isExternalInvite is true (since they are required)
                    if (this.isExternalInvite) {
                         if (this.companyType === 'existing') {
                             if (!this.selectedCompanyObj) {
                                 alert(this.$t('complete_campos_requeridos')); // Or a more specific message "Select a company"
                                 return;
                             }
                             // If company is selected, we assume data is valid because it comes from DB/API
                             // Ideally we should ensure externalCompanyName/Contact etc are set, but onCompanySelect handles it.
                             // Double check just in case selection didn't populate properly or was cleared?
                             if (!this.externalCompanyName) {
                                  // This shouldn't happen with correct onCompanySelect but good for safety
                                  alert(this.$t('complete_campos_requeridos'));
                                  return;
                             }

                         } else {
                             // Unregistered company: manual fields required
                             if (!this.externalCompanyName || !this.externalContactName || !this.externalContactEmail) {
                                 alert(this.$t('complete_campos_requeridos'));
                                 return;
                             }
                         }
                    }

                    if (result || this.isExternalInvite) { // validateAll might fail for hidden fields or irrelevant checks if we don't manage scope, but we assume it passes or we bypass if external
                        this.loading_send = true
                        this.errores = []
                        this.get_current_date()
                        
                        let url = 'https://empresa-service.intrare.app/shipments/createShippingWindowInv/';
                        let data = {};

                        if (this.isExternalInvite) {
                            url = 'https://empresa-service.intrare.app/shipments/invite-external-company/';
                            data = {
                                shipping_window_id: this.info.shipping_window.id,
                                company_name: this.externalCompanyName,
                                admin_name: this.externalContactName,
                                admin_email: this.externalContactEmail
                            };
                        } else {
                            var guests = null
                            if (this.email !== null  && this.email !== undefined && this.email !== '' && this.email.length > 0) {
                                guests = []
                                for(let i = 0; i < this.email.length; i++) {
                                  guests.push({
                                     email: this.email[i].id_usuario.email
                                  })
                                }
                            }
                            data = {
                                idReferredInv: this.info.id,
                                guest: guests
                            };
                        }

                        console.log('Endpoint:', url);
                        console.log('Payload:', data);

                        const config = {
                            method: 'post',
                            url: url,
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: data
                        };
                        axios(config)
                            .then(ok => {
                                console.log('Invitación Creada Correctamente.')
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_alta'))
                                this.loading_send = false
                                this.$router.push({path: '/'})
                                // setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data) {
                                    this.errores = error.response.data
                                    if (error.response.data.non_field_errors) {
                                        this.errores.guest = error.response.data.non_field_errors[0]
                                    }
                                }
                                if(error.response.status == 403)
                                    this.dialog_sin_permisos = true
                                this.loading_send = false
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                    this.loading_send = false
                });
            },
            onCompanySelect(val) {
                 if (val) {
                    this.externalCompanyName = val.name
                    const contactName = (val.first_name || '') + ' ' + (val.last_name || '')
                    this.externalContactName = contactName.trim() !== '' ? contactName.trim() : val.name
                    // Check if email is directly on the object or nested in companyProvider
                    let email = val.email;
                    if (!email && val.companyProvider && val.companyProvider.email) {
                        email = val.companyProvider.email;
                    }
                    this.externalContactEmail = email || ''
                 }
            },
    fullNamePlusCellphone: item => {
        const u = item.id_usuario || {}
        return `${u.first_name || ''} ${u.last_name || ''} ${u.email || ''} ${item.celular || ''}`
    },
    getMovementTypeLabel() {
        if (!this.info || !this.info.shipping_window) return 'Movimiento'
        const movementType = this.info.shipping_window.tipo_movimiento
        if (movementType === 'RECEPCION') {
            return 'Recibo'
        }
        return 'Embarque'
    },
    clear () {
        this.$store.commit('snackbar_activate_false')
    },
    adminConfirmAction(action) {
        if (!this.info || !this.info.shipping_window || !this.info.shipping_window.id) {
            console.error('No ID found for shipping window');
            return;
        }
        this.loading_confirm = true;
        const uuid = this.info.shipping_window.id;
        const url = `https://empresa-service.intrare.app/shipments/admin-confirm/${uuid}/`;
        const data = { action: action };
        const config = {
            method: 'post',
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
            },
            data: data
        };
        axios(config)
            .then(response => {
                this.$store.commit('snackbar_activate_true');
                this.$store.commit('snackbar_change_message', action === 'confirm' ? 'Invitación aceptada' : 'Invitación rechazada');
                // Refresh data
                setTimeout(this.clear, 3000);
                this.get_info_invit_empresarial();
            })
            .catch(error => {
                console.error(error);
                alert('Error al procesar la acción');
            })
            .finally(() => {
                this.loading_confirm = false;
            });
    }
}
    }
</script>

<style scoped>
    .invitation-page {
        background: linear-gradient(180deg, #f4f7fb 0%, #ffffff 100%);
        min-height: 100%;
    }

    .invitation-wrapper {
        max-width: 1150px;
    }

    .invitation-card {
        border-radius: 12px;
        overflow: hidden;
    }

    .company-hero {
        background: linear-gradient(135deg, rgba(0, 43, 72, 0.06) 0%, rgba(25, 118, 210, 0.08) 100%);
        border: 1px solid rgba(25, 118, 210, 0.15);
        border-radius: 12px;
        padding: 16px 20px;
    }

    .company-hero-logo-col {
        padding: 8px 16px 8px 8px;
    }

    .company-hero-info-col {
        padding: 8px 8px 8px 20px;
        border-left: 2px solid rgba(25, 118, 210, 0.18);
    }

    @media (max-width: 599px) {
        .company-hero-info-col {
            border-left: none;
            border-top: 2px solid rgba(25, 118, 210, 0.18);
            padding: 16px 8px 8px 8px;
            text-align: center;
        }
    }

    .display-hero-title {
        font-size: 1.35rem;
        font-weight: 700;
        line-height: 1.3;
        margin-bottom: 4px;
    }

    .company-logo-frame {
        background: #ffffff;
        border: 1px solid #e5edf5;
        border-radius: 10px;
        padding: 12px;
        min-height: 164px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .logo-fallback {
        min-height: 140px;
        width: 100%;
        background: #f7fbff;
        border-radius: 8px;
    }

    .inv-details-table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 8px;
    }
    .inv-dt-label {
        width: 42%;
        padding: 7px 12px 7px 4px;
        vertical-align: middle;
        font-size: 0.82rem;
        color: #616161;
        white-space: nowrap;
    }
    .inv-dt-value {
        padding: 7px 4px;
        vertical-align: middle;
        font-size: 0.9rem;
        color: #212121;
        font-weight: 500;
    }
    .inv-details-table tbody tr:nth-child(even) {
        background: rgba(25, 118, 210, 0.04);
    }

    .centrado {
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
</style>
